import React, { Component } from "react";
//import Moment from 'react-moment';
import { css } from "aphrodite/no-important";
import { styles } from "./EnergyServicesHomeStyles";
import Header from "../components/Header";
import AssistedLivingNavigation from "../components/AssistedLivingNavigation";
import Loading from "../components/Loading";
import ApplianceListDisc from "../components/ApplianceListDisc";
import ApplianceNavigation from "../components/ApplianceNavigation";
import PageTitle from "../components/PageTitle";
import Timeline from "../components/Timeline";
import AppliancesList from "../components/AppliancesList";

import PopupWrapper from "../components/PopupWrapper";
import { appliancesActions } from "../_actions";
import { connect } from "react-redux";

class AssistedLivingAppliances extends Component {
  constructor(props) {
    super(props);

    const params = new URLSearchParams(props.location.search);
    if (params.get("tab") === "costly") {
      this.props.dispatch(appliancesActions.setTab("costly"))
    } else if (params.get("tab") === "all") {
      this.props.dispatch(appliancesActions.setTab("all"))
    } else {
      this.props.dispatch(
        appliancesActions.getDetail(
          this.props.authentication.user.dependant_user_id,
          "most_used"
        )
      );
    }

    
  }

  componentDidUpdate(prevProps) {
    if (this.props.appliances.tab !== prevProps.appliances.tab) {
      if (this.props.appliances.tab === "timeline") {
        this.props.dispatch(
          appliancesActions.getTimeline(
            this.props.authentication.user.dependant_user_id,
            Math.round(new Date() / 1000)
          )
        );
      } else if (this.props.appliances.tab === "used") {
        this.props.dispatch(
          appliancesActions.getDetail(
            this.props.authentication.user.dependant_user_id,
            "most_used"
          )
        );
      } else if (this.props.appliances.tab === "costly") {
        this.props.dispatch(
          appliancesActions.getDetail(
            this.props.authentication.user.dependant_user_id,
            "most_costly"
          )
        );
      } else if (this.props.appliances.tab === "all") {
        this.props.dispatch(
          appliancesActions.getDetail(
            this.props.authentication.user.dependant_user_id,
            "all"
          )
        );
      }
    }
  }

  render() {
    const { fetchingDetail, detail, tab } = this.props.appliances;

    return (
      <div>
        <Header
          title={"Parent's Home"}
          backTitle={"Dashboard"}
          isAssistedLiving={true}
          backHref={"/"}
        />
        <PageTitle title={"Appliances"} subTitle={detail && detail.subtitle} />
        <AssistedLivingNavigation {...this.props.location} />
        <div className={css(styles.innerNarrow)}>
          <PopupWrapper />
          <ApplianceNavigation {...this.props} />
          {fetchingDetail && <Loading />}
          {!fetchingDetail && detail && detail.appliances && (
            <div className={css(styles.appliancesContainer)}>
              {tab === "used" && (
                <AppliancesList
                  ordered={true}
                  type={"most_used"}
                  title="Most Used Appliances in the Last 7 Days"
                  appliances={detail.appliances}
                />
              )}
              {tab === "costly" && (
                <AppliancesList
                  ordered={true}
                  type={"most_costly"}
                  title="Most Costly Appliances in the Last 7 Days"
                  appliances={detail.appliances}
                />
              )}
              {tab === "all" && (
                <AppliancesList
                  title="All Appliances"
                  appliances={detail.appliances}
                />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { fetchingDetail } = state.appliances;
  const { alert } = state;
  const appliances = state.appliances;
  const authentication = state.authentication;
  return {
    fetchingDetail,
    alert,
    appliances,
    authentication
  };
}

export default connect(mapStateToProps)(AssistedLivingAppliances);
